export default Object.freeze({
    PRODUCT_DETAILS: "ProductDetails",
    LOGIN: "Login",
    ACCOUNT: "Account",
    USERS: "Users",
    DASHBOARD: "Dashboard",
    STORE: "Store",
    USER_DETAILS: "UserDetails",
    CHANGE_PASSWORD: "ChangePassword",
    RESET_PASSWORD: "ResetPassword",
    LOCATION_DETAILS: "LocationDetails",
    TOOLS_MENU: "ToolsMenu",
    NEW_USER: "NewUser",
    CHANGE_PASSWORD: "ChangePassword",
    DASHBOARD_RESKIN: "DashboardReskin",
});
